import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export function useDeleteOTP(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<void, AppMedError, number>({
        mutationKey: [QueryKeys.otp, 'delete'],
        mutationFn: async (id: number) => {
            return await OTPApi.deleteOTP(id);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId) 
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });
            
            notifications.show({
                title: t('otp.notifications.deleteSuccess.title'),
                message: t('otp.notifications.deleteSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.deleteError.title'),
                message: error?.message || t('otp.notifications.deleteError.message'),
                color: 'red',
            });
        },
    });
}
